import { IOutstandingOrdersFilter } from 'api/swaggerTypes';
import HyperLinkCell from './HyperLink';

const DATAGRIDCONSTANTS = {
    header: {
        Product: 152,
        Quantity: 92,
        Price: 152,
        Discount: 87,
        Total: 152,
        Description: 278,
    }
};

const ORDER_STATUS = {
    a: 'All',
    1: 'Incomplete',
    2: 'Active',
    3: 'On hold'
};

export const ParseOrderStatus = (status: IOutstandingOrdersFilter['OrderStatus']) => ORDER_STATUS?.[status] ?? '';

export const columns = [
    {
        dataField: 'ProductIdDisplay',
        caption: 'Product',
        width: DATAGRIDCONSTANTS.header.Product,
        allowResizing: false,
        allowSorting: false,
        allowEditing: false,
        fixed: true,
        cellComponent: HyperLinkCell,
    },

    {
        dataField: 'SuppliedQuantityDisplay',
        caption: 'Supplied',
        width: DATAGRIDCONSTANTS.header.Quantity,
        allowResizing: false,
        allowSorting: false,
        allowEditing: false,
        alignment: 'right',
    },
    {
        dataField: 'PriceDisplay',
        caption: 'Price',
        width: DATAGRIDCONSTANTS.header.Price,
        allowSorting: false,
        allowEditing: false,
        allowResizing: true,
        alignment: 'right',
    },
    {
        dataField: 'DiscountDisplay',
        caption: 'Discount',
        width: DATAGRIDCONSTANTS.header.Discount,
        allowResizing: true,
        allowSorting: false,
        allowEditing: false,
        alignment: 'right',
    },
    {
        dataField: 'Description',
        caption: 'Description',
        width: DATAGRIDCONSTANTS.header.Description,
        allowResizing: true,
        allowSorting: false,
        allowEditing: false,
    }
];
